@if (data && data.enableFooter) {
<div class="preview-footer-section" [class.mobile-view]="viewMode === 'mobile'"
  [style.background-color]="data.backgroundColor">
  <div class="preview-footer-inner"
    [style.align-items]="data.alignment"
    [class.mobile-view]="viewMode === 'mobile'"
    [style.text-align]="data.textAlign">
    <div class="preview-footer-title m-0"
    [class.mobile-view]="viewMode === 'mobile'"
      [style.color]="data.contentColor"
      [style.font-size]="data.contentFontSize + 'px'"
      [style.font-family]="data.contentFontFamily"
      [style.font-weight]="data.contentFontWeight">
      {{ data.content }}
    </div>
    @if (data.linkLabel) {
    <a class="preview-footer-link" [class.mobile-view]="viewMode === 'mobile'" [href]="data.linkUrl || '#'" [attr.target]="data.linkUrl ? '_blank' : null"
     >
      {{ data.linkLabel }}
    </a>
    }
  </div>
  @if (!data.promotionFlag) {
  <div class="preview-footer-powered-by" [class.mobile-view]="viewMode === 'mobile'">
    <span>Powered by </span>
    <img [class.mobile-view]="viewMode === 'mobile'" src="assets/images/logo/ICXBEE.svg" alt="ICXBee logo" />
  </div>
  }
</div>
}
